import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import permissions from "./modules/permissions";
import token from "./modules/token";
import patient from "./modules/patient";

import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    permissions,
    patient,
    token,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
